import React, { useState } from 'react'
import Menu from '@mui/material/Menu'

//images
import menuIcon from '../../../../assets/img/icons/table-menu.png'
import editIcon from '@/assets/img/icons/edit.svg'
import deleteIcon from '@/assets/img/icons/delete.svg'
import historyIcon from '@/assets/img/storage/icons/history.svg'
import addToStorageIcon from '@/assets/img/storage/icons/add-to-storage.svg'
import editQuantityIcon from '@/assets/img/storage/icons/edit-quantity.svg'
import transferIcon from '@/assets/img/storage/icons/transfer.svg'
import { trans } from '../../../../_providers/Translation'

function Index(props) {

    const [table, setTable] = useState({
        options: null
    })

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        })
    }

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        })
    }

    const handleEdit = id => {
        handleCloseMenu()

        props.handleEdit(id)
    }

    const handleCorrect = id => {
        handleCloseMenu()
        props.handleCorrect(id)
    }

    const handleAddInStorage = id => {
        handleCloseMenu()

        props.handleAddInStorage(id)
    }

    const handleDelete = id => {
        handleCloseMenu()

        props.handleDelete(id)
    }

    const handleTransfer = id => {
        handleCloseMenu()

        props.handleTransfer(id)
    }

    const handleAcceptTransfer = id => {
        handleCloseMenu()

        props.handleAcceptTransfer(id)
    }

    const handleHistory = id => {
        handleCloseMenu()

        props.handleHistory(id)
    }

    const handleTransferToOffice = id => {
        handleCloseMenu()

        props.handleTransferToOffice(id)
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >
                {props.transferable &&
                    <div className="menu-option" onClick={() => handleTransfer(props.id)}>
                        <img src={transferIcon} alt="edit" />
                        {trans('buttons.transfer')}
                    </div>
                }

                {props.canAcceptTransfer &&
                    <div className="menu-option" onClick={() => handleAcceptTransfer(props.id)}>
                        <img src={transferIcon} alt="edit" />
                        {trans('buttons.acceptTransfer')}
                    </div>
                }

                {props.allowTransferToOffice &&
                    <div className="menu-option" onClick={() => handleTransferToOffice(props.id)}>
                        <img src={transferIcon} alt="edit" />
                        {trans('buttons.transfer')}
                    </div>
                }

                {/* New option: Add in Storage */}
                <div className="menu-option" onClick={() => handleAddInStorage(props.id)}>
                    <img src={addToStorageIcon} alt="edit" />
                    {trans('buttons.addAvailabilityInStorage') || 'Add in Storage'}
                </div>

                <div className="menu-option" onClick={() => handleHistory(props.id)}>
                    <img src={historyIcon} alt="edit" />
                    {trans('buttons.history')}
                </div>

                {props.editable &&
                    <div className="menu-option" onClick={() => handleEdit(props.id)}>
                        <img src={editIcon} alt="edit" />
                        {trans('buttons.edit')}
                    </div>

                }
                {props.editable &&
                    <div className="menu-option" onClick={() => handleCorrect(props.id)}>
                        <img src={editQuantityIcon} alt="edit" />
                        Коригирай количеството
                    </div>

                }
                {props.deletable &&
                    <div
                        className="menu-option"
                        onClick={() => handleDelete(props.id)}
                        style={{
                            color: "#EC5252"
                        }}
                    >
                        <img src={deleteIcon} alt="delete" />
                        {trans('buttons.delete')}
                    </div>
                }
            </Menu>
        </>
    )
}

export default Index
